module.exports = __webpack_public_path__ + "media/images/b2b_admin/lines_mini_screen-46b09753ca0a1aaa4b1ca7f704902db6.png";